<script lang="ts" setup>
	import HotelRateSelectTerms from './HotelRateSelectTerms.vue'
	import SectionHeader from './ui/SectionHeader.vue'

	interface Props {
		currencyCode: string
		validationErrors: {
			default: string
		}
	}

	defineProps<Props>()

	const termsAndConditions = defineModel<{
		value: boolean
		attemptedToSubmit: boolean
	}>('termsAndConditions', {
		default: () => ({
			value: false,
			attemptedToSubmit: false,
		}),
	})
</script>

<template>
	<div class="bg-white rounded-xl border border-gray-200 overflow-hidden">
		<SectionHeader
			title="Términos Legales del Servicio"
			icon="verified_user"
			icon-bg-color="blue"
			icon-color="blue"
		/>

		<div class="p-4 lg:p-6">
			<p class="font-inter text-xs lg:text-sm text-gray-700 leading-relaxed">
				Al reservar acepto que revisé y estoy de acuerdo con el
				<RouterLink
					to="/legal/privacy"
					target="_blank"
					class="text-blue-600 hover:text-blue-800 underline font-medium"
				>
					Aviso de privacidad
				</RouterLink>
				y los
				<RouterLink
					to="/legal/terms-of-service"
					target="_blank"
					class="text-blue-600 hover:text-blue-800 underline font-medium"
				>
					Términos de uso.
				</RouterLink>
			</p>
		</div>
	</div>

	<HotelRateSelectTerms
		:validation-errors="validationErrors"
		:currency-code="currencyCode"
		v-model="termsAndConditions.value"
		:attempted-to-submit="termsAndConditions.attemptedToSubmit"
	/>
</template>
